<template>
  <div class="alert message-bar" role="alert">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
  .alert {
    background-color: color.adjust($error-color, $lightness: 50%);
  }
</style>
